module.exports = __webpack_public_path__ + "img/managebac.0cf9432f.png";